<div class="glap-main-container d-flex flex-column position-relative vh-100">
  <mat-toolbar class="bg-white" fade>
    <div class="top-header-left-container align-items-center d-flex gap-1 h-100 justify-content-center">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <div class="tag-line">
        <h1>Leaf Management System</h1>
      </div>
    </div>

    <span class="d-flex justify-content-center">
      <img class="login-logo" src="/assets/images/login-logo.png" alt="Login logo" />
    </span>
    <span class="glap-toolbar-spacer"></span>
    <!-- <button mat-icon-button class="example-icon me-3" aria-label="Example icon-button with share icon">
      <mat-icon><i class="icon-setting icons-font-size"></i></mat-icon>
    </button> -->

    <button [matMenuTriggerFor]="profile" mat-icon-button class="me-4 bg-secondary-subtle">
      <ng-container *ngIf="profileInfo?.givenName">
        <span class="fw-bold">{{ profileInfo!.givenName! | shortName }}</span>
      </ng-container>
    </button>

    <mat-menu #profile="matMenu" class="profile-card">
      <img class="profile-card-img-top" src="assets/images/profile-bg-top.png" alt="profile bg image" />
      <div class="profile-card-content text-center px-3 py-0 pb-3">
        <div class="user-img">
          <ng-container *ngIf="profileInfo?.givenName">
            <span class="fw-bold">{{
              profileInfo!.givenName! | shortName
              }}</span>
          </ng-container>
        </div>

        <div class="mb-3">
          <h2 class="user-name m-0">
            {{ profileInfo?.givenName }} {{ profileInfo?.surname }}
          </h2>
        </div>

        <div class="user-details d-flex flex-column gap-2 mb-3">
          <div class="d-flex text-start align-items-center">
            <div class="col-4 d-flex align-items-center">
              <i class="icon icon-user me-2" style="font-weight: 700"></i>
              <h3 class="m-0">User ID:</h3>
            </div>
            <div class="col-4">
              <p class="m-0">{{ userInfo?.accountId }}</p>
            </div>
          </div>

          <!-- <div class="d-flex text-start align-items-center">
            <div class="col-5 d-flex align-items-center">
              <i class="icon icon-location me-2"></i>
              <h3 class="m-0">Location:</h3>
            </div>
            <div class="col-7">
              <p class="m-0">EATHAM</p>
            </div>
          </div> -->
        </div>

        <div class="align-items-center d-inline-flex gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path d="M17.4414 14.8694L20.0014 12.2657L17.4414 9.66211" stroke="#292D32" stroke-width="1.5"
              stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.76172 12.2656H19.9317" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10"
              stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M11.7617 20.3411C7.34172 20.3411 3.76172 17.29 3.76172 12.2047C3.76172 7.1195 7.34172 4.06836 11.7617 4.06836"
              stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <!-- <ng-container *ngIf="loginDisplay"> -->
          <p class="m-0 text-decoration-underline" (click)="logoutSSO()">
            Logout
          </p>
        </div>
      </div>
    </mat-menu>
    <!-- <app-navebar></app-navebar> -->
  </mat-toolbar>

  <mat-sidenav-container class="bg-white glap-sidenav-container mt-0">
    <mat-sidenav #drawer class="sidenav pt-0" color="primary"
      [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [mode]="(isHandset$ | async) ? 'over' : 'side'"
      [opened]="(isHandset$ | async) === false">
      <!-- <mat-toolbar class="bg-white"></mat-toolbar> -->

      <mat-nav-list>
        <span *ngFor="let category of menuCategory; let first = first">
          <!-- <span *ngIf="item.children && item.children.length > 0"> -->

          <mat-accordion>
            <mat-expansion-panel [expanded]="first">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div>
                    <mat-icon><i class="icon icon-note-add"></i></mat-icon>
                    {{ category.featureCategoryName }}
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <span *ngFor="let feature of category.features">
                <mat-list-item appAccordionLink routerLinkActive="active" routerLink="{{ feature.featureUrl }}">
                  <a class="d-flex justify-content-center align-items-center align-self-stretch gap-3"
                    appAccordionToggle>
                    <span>{{ feature.featureName }}</span>
                  </a>
                </mat-list-item>
              </span>
            </mat-expansion-panel>
          </mat-accordion>
        </span>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content class="glap-content-wrapper">
      <div id="glap-content" class="glap-content h-100">
        <!-- Add Content Here -->
        <router-outlet></router-outlet>
      </div>

    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
